import { useTranslation } from 'react-i18next';

import { Button } from '../../../../../../../../../shared/components/UI/Button/Button';

import type { ResponseProjectBlock } from '../../../../../../../../../shared/entities/ResponseProjectBlock';
import { useResponseProjectAssistant } from '../../responseProjectAssistant/context/responseProjectAssistant.provider';

interface BlockAssistantProps {
  block: ResponseProjectBlock;
}

export function BlockAssistant({ block }: BlockAssistantProps) {
  const { t } = useTranslation('bidResponse');
  const { onOpenAssistant } = useResponseProjectAssistant();

  function openAssistant() {
    onOpenAssistant(block);
  }

  return (
    <Button variant="outline" onClick={openAssistant}>
      {t('projectDetail.assistant.trigger')}
    </Button>
  );
}
